module.exports = __webpack_public_path__ + "static/media/sideMatGery10.53513a3f.png";